/* HoloHunterz image protection: a deterrent, not a vault. Anything shown in a browser can still be captured (screenshots, dev tools, view-source).
   - blocks the context menu on images and image areas (right-click, long-press save), including CSS background pictures
   - blocks image dragging, marks images draggable=false, keeps text selection / copy / forms / keyboard navigation untouched
   - blocks only Ctrl/Cmd+S and Ctrl/Cmd+U outside form fields (nothing else; no F12 / dev-tools blocking, no copy blocking)
   - also covers images added later (quick-view, cart drawer, zoom viewer, slideshow, section re-renders) with a MutationObserver
   Off in the theme editor (Shopify design mode) so the editor stays usable, and when the theme setting is off. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('holo-protect')) return;
  if (window.Shopify && window.Shopify.designMode) { root.classList.remove('holo-protect'); return; }

  var MEDIA = { IMG: 1, PICTURE: 1, CANVAS: 1, VIDEO: 1 };
  var EDITABLE = 'input, textarea, select, [contenteditable=""], [contenteditable="true"]';

  function editable(t) { return !!(t && t.closest && t.closest(EDITABLE)); }

  function bgUrl(el) {
    if (!el || el === document.body || el === root || el.nodeType !== 1) return false;
    try {
      var cs = window.getComputedStyle(el);
      if (cs.backgroundImage && cs.backgroundImage.indexOf('url(') !== -1) return true;
      var b = window.getComputedStyle(el, '::before'), a = window.getComputedStyle(el, '::after');
      return (b.backgroundImage && b.backgroundImage.indexOf('url(') !== -1) || (a.backgroundImage && a.backgroundImage.indexOf('url(') !== -1);
    } catch (e) { return false; }
  }

  // images ignore the pointer (CSS), so look for any <img>/video/canvas whose box contains the point instead of relying on the hit target.
  // The image's own parent box must also be hit-testable at that point, which rules out images that are clipped, off-screen or scrolled away.
  function mediaInside(el, x, y) {
    if (typeof x !== 'number' || !document.elementsFromPoint) return false;
    var stack;
    try { stack = document.elementsFromPoint(x, y); } catch (err) { return false; }
    var list = document.querySelectorAll('img, video, canvas'), n = Math.min(list.length, 800);
    for (var i = 0; i < n; i++) {
      var m = list[i], r = m.getBoundingClientRect();
      if (!(r.width > 0 && r.height > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom)) continue;
      if (m.tagName === 'IMG') { var cs = window.getComputedStyle(m); if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') continue; }
      var par = m.parentElement; if (par && par.tagName === 'PICTURE') par = par.parentElement;
      if (!par || par === document.body || stack.indexOf(par) !== -1 || stack.indexOf(m) !== -1) return true;
    }
    return false;
  }

  // is there a picture (an <img>, a CSS background picture, a video poster, a canvas) under this point?
  function imageAt(e) {
    var t = e.target;
    if (t && t.nodeType === 1 && (MEDIA[t.tagName] || t.closest('picture, .holo-pbox'))) return true;
    var stack = [];
    try { if (typeof e.clientX === 'number' && document.elementsFromPoint) stack = document.elementsFromPoint(e.clientX, e.clientY).slice(0, 12); } catch (err) { stack = []; }
    if (!stack.length && t && t.nodeType === 1) stack = [t];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el === document.body || el === root) break;
      if (MEDIA[el.tagName] || bgUrl(el) || (i === 0 && mediaInside(el, e.clientX, e.clientY))) return true;
    }
    return false;
  }

  /* 1: context menu (right-click, long-press) */
  function onContext(e) {
    var t = e.target;
    if (editable(t)) return;
    // plain text (a heading, paragraph, link text) over a CSS background picture keeps its normal menu (copy etc.); real pictures under the point never do
    if (t && t.nodeType === 1 && !MEDIA[t.tagName] && hasOwnText(t) && !mediaInside(t, e.clientX, e.clientY)) return;
    if (imageAt(e)) { e.preventDefault(); }
  }
  document.addEventListener('contextmenu', onContext, true);

  // a link that holds an image, or the stretched title link of a product / collection card that has one
  function linkHasImage(a) {
    if (a.querySelector('img, picture')) return true;
    var box = a.closest('li, .card-wrapper, .card, .grid__item, .product-card-wrapper') || a.parentElement;
    return !!(box && box.querySelector('img, picture'));
  }

  /* 2: dragging */
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || editable(t)) return; // dragging selected text (a text node) stays allowed
    if (MEDIA[t.tagName] || t.closest('picture, .holo-pbox') || (t.tagName === 'A' && linkHasImage(t)) || bgUrl(t) || mediaInside(t, e.clientX, e.clientY)) e.preventDefault();
  }, true);

  /* 5: save / view-source shortcuts only (never in form fields, never with extra modifiers that assistive tech or browsers use) */
  document.addEventListener('keydown', function (e) {
    if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey || editable(e.target)) return;
    var k = (e.key || '').toLowerCase();
    if (k === 's' || k === 'u') e.preventDefault();
  }, true);

  /* mark images and the boxes around them */
  function hasOwnText(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && /\S/.test(n.nodeValue)) return true;
    return false;
  }
  function mark(img) {
    if (img.__holoP) return;
    img.__holoP = true;
    img.setAttribute('draggable', 'false');
    var p = img.parentElement;
    if (p && p.tagName === 'PICTURE') p = p.parentElement;
    if (p && p !== document.body && !hasOwnText(p) && !p.matches('button, a, label')) p.classList.add('holo-pbox');
    var a = img.closest && img.closest('a');
    if (a) a.setAttribute('draggable', 'false');
  }
  function markVideo(v) {
    if (v.__holoP) return;
    v.__holoP = true;
    try { v.setAttribute('controlsList', 'nodownload noremoteplayback'); } catch (e) { /* ignore */ }
  }
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IMG') mark(node);
    else if (node.tagName === 'VIDEO') markVideo(node);
    if (node.querySelectorAll) {
      var im = node.querySelectorAll('img'), vd = node.querySelectorAll('video'), i;
      for (i = 0; i < im.length; i++) mark(im[i]);
      for (i = 0; i < vd.length; i++) markVideo(vd[i]);
    }
  }

  /* 7: images added later. Perf: the event handlers above already protect every image from the first moment
     (they check tag names / picture / backgrounds directly), so the marking pass and observer only start
     after the page has loaded, in idle time, instead of competing with first paint. */
  var queue = [], pending = false;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
  function flush() { pending = false; var q = queue; queue = []; for (var i = 0; i < q.length; i++) scan(q[i]); }
  function start() {
    scan(document.body);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) for (var j = 0; j < muts[i].addedNodes.length; j++) if (muts[i].addedNodes[j].nodeType === 1) queue.push(muts[i].addedNodes[j]);
        if (queue.length && !pending) { pending = true; idle(flush, { timeout: 500 }); }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  function later() { idle(start, { timeout: 3000 }); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
